import { FC } from "react";
import {
  Box,
  Button,
  Flex,
  Space,
  Text,
  Textarea,
  Title,
  Checkbox,
} from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { SelectInputRef, BankHoliday, type Order } from "@jasper/shared";
import { useOrderRedoRequest } from "./useOrderRedoRequest";

type OrderGetRedoProps = {
  order: Order;
  userEmail: string;
  bankHolidays: BankHoliday[];
  closeModal?: () => void;
};

export const OrderGetRedo: FC<OrderGetRedoProps> = ({
  order,
  bankHolidays,
  closeModal = () => null,
  userEmail,
}) => {
  const {
    pickupForm,
    submit,
    confirmSent,
    setRedoRequestMessage,
    canRequestPickup,
    isPickupRequested,
    setIsPickupRequested,
    pickupDateOptions,
    clinicCloseTime,
    setClinicCloseTime,
    isLoading,
    error,
    newDeliveryDate,
  } = useOrderRedoRequest({ order, bankHolidays, userEmail });

  if (newDeliveryDate) {
    return (
      <div style={{ textAlign: "center" }}>
        <Title
          order={3}
        >{`Date de livraison estimée : ${newDeliveryDate}`}</Title>
        <Space h="md" />
        <Button
          onClick={() => confirmSent(closeModal)}
          style={{
            backgroundColor: "green",
          }}
        >
          Valider
        </Button>
      </div>
    );
  }

  return (
    <Box>
      <Flex w="100%" justify="right">
        <IconX
          onClick={() => closeModal()}
          style={{ cursor: "pointer" }}
          color="black"
        />
      </Flex>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title
          order={2}
          style={theme => ({
            color: theme.colors.primary[5],
          })}
        >
          Demande de refabrication pour la commande:
        </Title>
        <Space h="md" />
        <Title
          order={2}
          style={theme => ({
            color: theme.colors.primary[5],
          })}
        >{`${order.orderReference}`}</Title>
        <Space h="md" />
        <Title order={4}>
          Votre conseiller Jasper reviendra vers vous très rapidement.
        </Title>
        <Space h="lg" />
        <Textarea
          color="primary"
          placeholder="Veuillez indiquer ce que vous souhaitez pour la refabrication"
          onChange={event => setRedoRequestMessage(event.target.value)}
          w="80%"
          autosize
          minRows={4}
          maxRows={12}
        />
        <Space h="md" />
        {canRequestPickup && (
          <>
            <Checkbox
              onChange={e => setIsPickupRequested(e.target.checked)}
              label="Souhaitez-vous également un ramassage ?"
            />
            <Space h="md" />
          </>
        )}
        {isPickupRequested && (
          <>
            <SelectInputRef
              name="date"
              label={"Date du ramassage"}
              errors={pickupForm.formState.errors}
              control={pickupForm.control}
              data={pickupDateOptions}
            />
            <div style={{ paddingBottom: "1rem" }}>
              <Text>Heure de fermeture du cabinet</Text>
              <input
                type="time"
                style={{ width: "100%" }}
                value={clinicCloseTime}
                onChange={e => setClinicCloseTime(e.target.value)}
              />
            </div>
          </>
        )}
        <Button onClick={submit} disabled={isLoading}>
          {isLoading ? "Création du ramassage en cours.." : "Envoyer"}
        </Button>
        {error && (
          <>
            <Space h="sm" />
            <Text
              size="sm"
              style={theme => ({
                color: theme.colors.red[5],
              })}
            >
              Une erreur est survenue, veuillez contacter votre conseiller
              Jasper directement
            </Text>
          </>
        )}
      </Box>
      <Space h="md" />
    </Box>
  );
};
